import IUserData from '../DataObject/IUserData';
import IPublishService from './IPublishService';

export enum UserPathName {
    Login = 'auth.login',
    Balance = 'auth.balance',
}

export type UserPublishDataType = {
    [UserPathName.Balance]: number;
    [UserPathName.Login]: IUserData;
};

export default interface IUserService extends IPublishService<UserPublishDataType> {
    login(): Promise<IUserData>;
}
